import { HelmetProvider, Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

// routes
import Router from './routes';

// ----------------------------------------------------------------------

export default function App() {
  const Routing = Router();
  const { t } = useTranslation();
  
  return (
    <HelmetProvider>
      <Helmet>
        <title>{t('app.title')}</title>
      </Helmet>
      {Routing}
    </HelmetProvider>
  );
}
